import axios from 'axios';

const client = axios.create({
  // Local
  // baseURL: 'http://localhost:8080/'
  
  // UAT
  // baseURL: 'https://uat-fcs-executivedashboard.innive.com/'

  // Prod
  // baseURL: 'https://fcs.executivedashboard.innive.com/'

  // Dev
  baseURL: 'https://fdsdashboardapi-wckqd7o3eq-uw.a.run.app'
});

export default client;
